// ROUTES
import { ROUTE_SGU, ROUTE_POUPATEMPO } from 'routes/paths';

// USUARIOS
export const ROUTE_SGU_USUARIO_CADASTRO_CONSULTA = `${ROUTE_POUPATEMPO}${ROUTE_SGU}/usuario/cadastro-consulta`;
export const ROUTE_SGU_USUARIO_CADASTRO = `${ROUTE_POUPATEMPO}${ROUTE_SGU}/usuario/cadastro`;
export const ROUTE_SGU_USUARIO_CADASTRO_EDITAR = `${ROUTE_POUPATEMPO}${ROUTE_SGU}/usuario/cadastro/editar`;
export const ROUTE_SGU_USUARIO_CADASTRO_MAINFRAME = `${ROUTE_POUPATEMPO}${ROUTE_SGU}/usuario/cadastro-mainframe`;
